import React from 'react';
import { FormulaComponentProps } from '../../types/index';
import { CURATED_SOURCES_VDA } from '../../constants';
import { MathMLRenderer, createMathML } from '../shared/MathMLRenderer';
import { WeightTable } from '../shared/WeightTable';

export const VdaScoreCurated: React.FC<FormulaComponentProps> = ({ className, style }) => {
  const sourcesText = CURATED_SOURCES_VDA.join(', ');
  
  const introMath = createMathML(`
    <mrow>
      <mtext>The set C of CURATED sources is defined as:</mtext>
    </mrow>
  `, 'inline');

  const setDefinition = createMathML(`
    <mrow>
      <mi>C</mi>
      <mo>=</mo>
      <mo stretchy="true" form="prefix">&#123;</mo>
      <mrow>
        <mi>${sourcesText}</mi>
      </mrow>
      <mo stretchy="true" form="postfix">&#125;</mo>
    </mrow>
  `);

  const subsetDefinition = createMathML(`
    <mrow>
      <mtext>Given a subset</mtext>
      <mspace width="0.222em" />
      <msub>
        <mi>S</mi>
        <mi>C</mi>
      </msub>
      <mo>,</mo>
      <mspace width="0.222em" />
      <msub>
        <mi>S</mi>
        <mi>C</mi>
      </msub>
      <mspace width="0.222em" />
      <mo>⊆</mo>
      <mspace width="0.222em" />
      <mi>C</mi>
      <mo>,</mo>
      <mspace width="0.222em" />
      <msub>
        <mi>W</mi>
        <mi>C</mi>
      </msub>
      <mspace width="0.222em" />
      <mtext>is defined as:</mtext>
    </mrow>
  `, 'inline');

  const weightConditions = [
    { weight: 0.7, condition: '|S_C| > 2' },
    { weight: 0.6, condition: '|S_C| = 2' },
    { weight: 0.4, condition: '|S_C| = 1' },
    { weight: 0, condition: '|S_C| = 0' },
  ];

  return (
    <div className={className} style={style}>
      <MathMLRenderer mathML={introMath} />
      <MathMLRenderer mathML={setDefinition} />
      <MathMLRenderer mathML={subsetDefinition} className="pl-4" />
      <br />
      <WeightTable variable="C" conditions={weightConditions} />
    </div>
  );
};